<div class="container-div d-flex justify-content-between flex-column">
  <button class="close-box" (click)="onCloseDialog()">
    <div class="close-btn"></div>
  </button>
  <div class="heading-div d-flex justify-content-between">
    <span class="headingText">Specify the {{rowData.address_attribute.stateAttributeName | titlecase}}, {{rowData.address_attribute.districtAttributeName | titlecase}} and {{rowData.address_attribute.localAdmName | titlecase}} for - ({{
      rowData.userDetails.address
      }}, 
      @if(rowData.userDetails?.district){
        {{ rowData.userDetails.district }}, 
      }

      @if(rowData.userDetails?.state){
        {{ rowData.userDetails.state }}
      }
      )</span>
  </div>
  <form [formGroup]="stateDetails">
    <div class="input-container d-flex justify-content-between">
      <div class="input-content">
        <span class="input-text">{{rowData.address_attribute.stateAttributeName | titlecase}}*</span>

        <input matInput formControlName="stateName" placeholder="Enter the state" class="dp-input-control input-div"
          [matAutocomplete]="stateAuto" />
        <mat-autocomplete #stateAuto="matAutocomplete" (optionSelected)="onStateSelected($event.option.value)">
          @for (item of filteredOptions | async ; track $index) {
          <mat-option [value]="item.state_name">{{
            item.state_name
            }}</mat-option>
          }
        </mat-autocomplete>
      </div>
      <div class="input-content">
        <span class="input-text">{{rowData.address_attribute.districtAttributeName | titlecase}}*</span>

        <input type="text" [readOnly]="districtNameDisabled" formControlName="districtName"
          placeholder="Enter the district" class="dp-input-control input-div" [matAutocomplete]="districtAuto" />
        <mat-autocomplete #districtAuto="matAutocomplete" (optionSelected)="onDistrictSelected($event.option.value)">
          @for (item of filteredOptionsD | async ; track $index) {
          <mat-option [value]="item.district_name">{{
            item.district_name
            }}</mat-option>
          }
        </mat-autocomplete>
      </div>
      <div class="input-content">
        <span class="input-text">{{rowData.address_attribute.localAdmName | titlecase}}*</span>

        <input type="text" [readOnly]="municipalityNameDisabled" formControlName="municipalityName"
          placeholder="Enter the municipality" class="dp-input-control input-div"
          [matAutocomplete]="municipalityAuto" />
        <mat-autocomplete #municipalityAuto="matAutocomplete"
          (optionSelected)="onMunicipalitySelected($event.option.value)">
          @for (item of filteredOptionsM | async ; track $index) {
          <mat-option [value]="item.municipality_name">{{
            item.municipality_name
            }}</mat-option>

          }
        </mat-autocomplete>
      </div>
    </div>
    <div class="btn-submit">
      <button class="dp-secondary-btn btn-div d-flex align-items-center" (click)="onSubmit()">
        <span class="filter-text">Submit</span>
      </button>
    </div>
  </form>
</div>